export const SET_HISTORY = 'SET_HISTORY';
export const SET_LOCATION_STATE = 'SET_LOCATION_STATE';
export const UPDATE_LOCATION_STATE = 'UPDATE_LOCATION_STATE';
export const SET_HISTORY_AND_LOCATION_STATE = 'SET_HISTORY_AND_LOCATION_STATE';
export const SET_COMBINED_ROUTE_PARAMS = 'SET_COMBINED_ROUTE_PARAMS';

export const setCombinedRouteParams = ({ locationState, routeParams, locationSearch, trackingPathName }) => ({
  type: SET_COMBINED_ROUTE_PARAMS,
  payload: { locationState, routeParams, locationSearch, trackingPathName },
});
export const setHistoryAndLocationState = (history) => ({
  type: SET_HISTORY_AND_LOCATION_STATE,
  payload: history,
});

export const setHistory = (history) => ({
  type: SET_HISTORY,
  payload: history,
});

export const setLocationState = (locationState) => ({
  type: SET_LOCATION_STATE,
  payload: locationState,
});

export const updateLocationState = (locationState) => ({
  type: UPDATE_LOCATION_STATE,
  payload: locationState,
});
